import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { DynamicFormModule } from 'core/dynamic-form';
import { FixedScrollDirective } from 'core/shared-components';
import { DsgTranslatePipe } from '../../pipes/translate.pipe';
import { AuthComponent } from './auth.component';
import { OidcLogoutComponent } from './oidc-logout/oidc-logout.component';
import { OidcCallbackMockComponent } from './oidc/oidc-callback.mock.component';



@NgModule({
  declarations: [
    AuthComponent,
    OidcCallbackMockComponent,
    OidcLogoutComponent
  ],
  imports: [
    CommonModule,
    MatCardModule,
    DsgTranslatePipe,
    DynamicFormModule,
    MatButtonModule,
    FixedScrollDirective
  ]
})
export class AuthModule { }
